export interface CallRecord {
  id: string
  contact: string
  phone: string
  date: string // ISO yyyy-mm-dd
  time: string // e.g. "9:42 AM"
  durationSec: number // 0 if missed
  answered: boolean
  outcome: string // short note, e.g. "Left voicemail", "Booked app't"
}

export function answeredCount(calls: CallRecord[]): number {
  return calls.filter((c) => c.answered).length
}

export function formatDuration(sec: number): string {
  if (sec <= 0) return '—'
  const m = Math.floor(sec / 60)
  const s = sec % 60
  if (m === 0) return `${s}s`
  return `${m}m ${s.toString().padStart(2, '0')}s`
}

export function formatCallDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  })
}
